module.exports = __webpack_public_path__ + "img/page.515f82d7.png";